import { getLocalDateTimeString } from "../utils/timezoneUtils";
import React, { createContext, useState } from "react";

interface UserSelectedProviderProps {
  children: React.ReactNode;
}

interface UserSelectedContextType {
 // User selected parameter id
 userSelectedParameterId: number;
 setUserSelectedParameterId: (_parameterId: number) => void;

// User selected second parameter id
 userSelectedParameterId2: number;
 setUserSelectedParameterId2: (_parameterId: number) => void;

 // User selected reports active tab
 reportsActiveTab: 'live' | 'statistical';
 setReportsActiveTab: (_reportsActiveTab: 'live' | 'statistical') => void;

 // User selected settings active tab
 settingsActiveTab: 'account' | 'preferences' | 'api';
 setSettingsActiveTab: (_settingsActiveTab: 'account' | 'preferences' | 'api') => void;

 // User selected time range (for device pages)
 userSelectedTimeRange: string;
 setUserSelectedTimeRange: (_timeRange: string) => void;

 // User selected Live Data Reports time range
 userSelectedLiveDataTimeRange: string;
 setUserSelectedLiveDataTimeRange: (_timeRange: string) => void;

 // User selected Statistical Reports time range
 userSelectedReportsTimeRange: string;
 setUserSelectedReportsTimeRange: (_timeRange: string) => void;

 // User selected custom from date
 customFromDate: string;
 setCustomFromDate: (_customFromDate: string) => void;

 // User selected custom to date
 customToDate: string;
 setCustomToDate: (_customToDate: string) => void;

   // Bottom Bar functionality
   isBottomBarHidden: boolean;
   hideBottomBar: () => void;
   showBottomBar: () => void;
}

export const UserSelectedContext = createContext<UserSelectedContextType | undefined>(undefined);

export const UserSelectedProvider: React.FC<UserSelectedProviderProps> = ({ children }) => {

  const [userSelectedParameterId, setUserSelectedParameterId] = useState<number>(0);
  const [userSelectedParameterId2, setUserSelectedParameterId2] = useState<number>(0)
  const [reportsActiveTab, setReportsActiveTab] = useState<'live' | 'statistical'>('live');
  const [settingsActiveTab, setSettingsActiveTab] = useState<'account' | 'preferences' | 'api'>('account');
  const [userSelectedTimeRange, setUserSelectedTimeRange] = useState<string>('12h');
  const [userSelectedLiveDataTimeRange, setUserSelectedLiveDataTimeRange] = useState<string>('12h');
  const [userSelectedReportsTimeRange, setUserSelectedReportsTimeRange] = useState<string>('12h');
  const [customFromDate, setCustomFromDate] = useState<string>(
    getLocalDateTimeString(new Date(new Date().setDate(new Date().getDate() - 30)))
  );
  const [customToDate, setCustomToDate] = useState<string>(
    getLocalDateTimeString(new Date())
  );

  const [isBottomBarHidden, setIsBottomBarHidden] = useState(false);

  /* Hide bottom bar on iOS and Android*/
  const hideBottomBar = () => {
    setIsBottomBarHidden(true);
  }

  const showBottomBar = () => {
    setIsBottomBarHidden(false);
  }

  // Export the context
  const contextValue: UserSelectedContextType = {
    userSelectedParameterId,
    setUserSelectedParameterId,
    userSelectedParameterId2,
    setUserSelectedParameterId2,
    reportsActiveTab,
    setReportsActiveTab,
    settingsActiveTab,
    setSettingsActiveTab,
    userSelectedTimeRange,
    setUserSelectedTimeRange,
    userSelectedLiveDataTimeRange,
    setUserSelectedLiveDataTimeRange,
    userSelectedReportsTimeRange,
    setUserSelectedReportsTimeRange,
    customFromDate,
    setCustomFromDate,
    customToDate,
    setCustomToDate,
    isBottomBarHidden,
    hideBottomBar,
    showBottomBar,
  };

  return <UserSelectedContext.Provider value={contextValue}>{children}</UserSelectedContext.Provider>;
};